exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup-container[data-v-72bb225d]{z-index:10;position:absolute;top:14px;left:0}.popup-container .popup-text[data-v-72bb225d]{opacity:0.8}.popup-container .bestseller-popup[data-v-72bb225d]{z-index:10;margin:0;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content}.popup-container .popup[data-v-72bb225d]{z-index:9;opacity:0.1}\n", ""]);

// exports
